import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Rating } from '@mui/material';
import { FaChevronDown } from 'react-icons/fa6';
import { RiStarSmileLine } from 'react-icons/ri';
import './style.css';
import apiService from 'services/apiService';

const StarIcon = (props) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14 5.15377L9.07398 4.56218L6.99737 0L4.92077 4.56218L0 5.15377L3.638 8.57008L2.67593 13.5L6.99737 11.043L11.3241 13.5L10.362 8.57008L14 5.15377Z"
        fill="#F2AE40"
      />
    </svg>
  );
};

const FeedbackModal = ({ reviewModal, setreviewModal, Reviews }) => {
  console.log('reviewModalreviewModal', reviewModal, Reviews);

  const [showReviews, setShowReviews] = useState(false);
  const [view, setReviews] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [answer, setAnswer] = useState('');

  const toggleModal = () => {
    setreviewModal(!reviewModal);
  };

  const detailForm = async (data) => {
    try {
      setIsLoading(true);
      const response = await apiService.get(`contracts/${data}`);

      if (response?.data) {
        setIsLoading(false);
        setReviews(response?.data);
      }
    } catch (e) {
      setIsLoading(false);
      console.log('Error fetching users:', e);
    }
  };

  React.useEffect(() => {
    if (Reviews) {
      // Check if ID exists
      detailForm(Reviews);
    }
  }, [Reviews]);

  React?.useEffect(() => {
    if (view?.physician?.ratings?.length > 0) {
      setAnswer(view.physician.ratings[0]);
    }
  }, [view?.physician?.ratings]);

  return (
    <div>
      {/* Modal */}
      {isLoading ? (
        <div></div>
      ) : (
        <Modal
          isOpen={reviewModal}
          toggle={toggleModal}
          backdrop="static"
          className="max-w-lg mx-auto"
          cssModule={{ 'modal-content': 'modal-content-for-reviews' }}
          centered
        >
          <ModalHeader
            toggle={toggleModal}
            cssModule={{ 'btn-close': 'btn-close-rating' }}
            className="flex justify-between"
          >
            <div className="flex items-center justify-between w-full gap-3">
              <RiStarSmileLine
                height={19}
                width={20}
                className={`self-center box-content p-2.5 border rounded-full`}
                onClick={() => {
                  setreviewModal(!reviewModal);
                }}
              />
              <h3
                className={`font-medium text-base m-0 flex flex-col max-w-[280px] `}
              >
                <div>{`Rate Dr. ${view?.physician?.user?.firstName} ${
                  view?.physician?.user?.lastName
                }`}</div>

                <span className="font-normal text-sm text-[#525866]">
                  Provide us with feedback
                </span>
              </h3>
            </div>
          </ModalHeader>
          <ModalBody className="">
            {/* Main Rating */}
            <div className="flex justify-between border-b">
              <div className="flex gap-3  pb-4 ">
                <h3 className="text-[40px] font-medium mt-1.5">
                  {Number(view?.physician?.avg_rating || 0).toFixed(1)}
                </h3>
                <div className=" mt-2.5 h-[50px] self-strech bg-[#E2E4E9] w-[1px] " />
                <div className=" mt-2">
                  <Rating
                    name="read-only"
                    value={view?.physician?.avg_rating}
                    readOnly
                    precision={0.5}
                  />
                  <div className="flex gap-2">
                    <p className="font-medium text-[#525866] m-0 underline cursor-pointer">
                      {view?.physician?.ratings?.length} reviews
                    </p>
                  </div>
                </div>
              </div>
              <div
                className={`text-[#525866] self-center cursor-pointer mt-[-32px] border rounded px-[5.42px] py-[5.42px] `}
                onClick={() => setShowReviews(!showReviews)}
              >
                <FaChevronDown
                  className={`h-[9.55px] w-[9.55px] transition delay-50 duration-200 ease-in-out ${
                    showReviews ? 'rotate-180' : ''
                  } `}
                />
              </div>
            </div>

            {/* Reviews List */}
            {showReviews && (
              <div className="space-y-4 mb-6 mt-6  overflow-y-auto h-[300px]">
                {view?.physician?.ratings.map((review, index) => {
                  return (
                    <div
                      onClick={() => {
                        setAnswer(review);
                      }}
                      key={index}
                      className="border-b pb-2 overflow-y-auto h-[100px]"
                    >
                      <div className="flex">
                        <h3 className="font-medium text-sm">
                          <span> {review.hospital_manager?.firstName}</span>{' '}
                          <span> {review.hospital_manager?.lastName}</span>
                        </h3>
                        <p className="ml-2 text-xs font-normal text-gray-500 self-center  ">
                          {review.date}
                        </p>
                      </div>

                      <div className="flex gap-2 ">
                        <Rating
                          name={`rating-${index}`}
                          value={review.avg_rating}
                          readOnly
                          precision={0.5}
                          size="medium"
                          className="ml-1"
                        />
                        <p className="text-sm font-normal text-gray-600 text-center self-center">
                          ({review.avg_rating})
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Rating Breakdown */}
            <div className="mt-4 mb-2">
              <div className="flex w-full mt-2 gap-3 h-[20px]">
                <div className="w-[338px] bg-[#F6F8FA] h-[12px] rounded-xs mt-[3.5px]">
                  <div
                    style={{ width: `${answer?.ratings?.[0]}0%` }}
                    className="bg-[#F2AE40] h-[12px]   rounded-xs"
                  ></div>
                </div>
                <div className="flex gap-2 ">
                  <span className=" text-sm font-normal slef-start">
                    {answer?.ratings?.[0]}
                  </span>
                  <StarIcon className="mt-[2.5px]" />
                </div>
              </div>
              {/* DIVIDING BAR */}
              <div className="flex w-full mt-2 gap-3 h-[20px]">
                <div className="w-[338px] bg-[#F6F8FA] h-[12px] rounded-xs mt-[3.5px]">
                  <div
                    style={{ width: `${answer?.ratings?.[1]}0%` }}
                    className="bg-[#F2AE40] h-[12px]   rounded-xs "
                  ></div>
                </div>
                <div className="flex gap-2 ">
                  <span className=" text-sm font-normal slef-start">
                    {answer?.ratings?.[1]}
                  </span>
                  <StarIcon className="mt-[2.5px]" />
                </div>
              </div>
              {/* DIVIDING BAR */}
              <div className="flex w-full mt-2 gap-3 h-[20px]">
                <div className="w-[338px] bg-[#F6F8FA] h-[12px] rounded-xs mt-[3.5px]">
                  <div
                    style={{ width: `${answer?.ratings?.[2]}0%` }}
                    className="bg-[#F2AE40] h-[12px]  rounded-xs "
                  ></div>
                </div>
                <div className="flex gap-2 ">
                  <span className=" text-sm font-normal slef-start">
                    {answer?.ratings?.[2]}
                  </span>
                  <StarIcon className="mt-[2.5px]" />
                </div>
              </div>
              {/* DIVIDING BAR */}
              <div className="flex w-full mt-2 gap-3 h-[20px]">
                <div className="w-[338px] bg-[#F6F8FA] h-[12px] rounded-xs mt-[3.5px]">
                  <div
                    style={{ width: `${answer?.ratings?.[3]}0%` }}
                    className="bg-[#F2AE40] h-[12px]  rounded-xs  overflow-hidden"
                  ></div>
                </div>
                <div className="flex gap-2 ">
                  <span className=" text-sm font-normal slef-start">
                    {answer?.ratings?.[3]}
                  </span>
                  <StarIcon className="mt-[2.5px]" />
                </div>
              </div>
              {/* DIVIDING BAR */}
              <div className="flex w-full mt-2 gap-3 h-[20px]">
                <div className="w-[338px] bg-[#F6F8FA] h-[12px] rounded-xs mt-[3.5px]">
                  <div
                    style={{ width: `${answer?.ratings?.[4]}0%` }}
                    className="bg-[#F2AE40] h-[12px]  rounded-xs "
                  ></div>
                </div>
                <div className="flex gap-2 ">
                  <span className=" text-sm font-normal slef-start">
                    {answer?.ratings?.[4]}
                  </span>
                  <StarIcon className="mt-[2.5px]" />
                </div>
              </div>
            </div>
          </ModalBody>
        </Modal>
      )}
    </div>
  );
};

export default FeedbackModal;
